import qs from "querystring";
import axios from "axios";
import $ from "../config";

export const API = (props) => {
  const { url = '', method = '', data = {}, headers = {}, timeout = 10000, responseType = 'json', params = {}, } = props
  return new Promise((resolve, reject) => {
    console.log('params => ', params)
    axios({
      url,
      method,
      data,
      headers,
      timeout,
      responseType,
      params,
    })
    .then(resp => {
      resolve(resp.data);
    })
    .catch(err => {
      reject(err);
    });
  });
}